import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { TableBody } from "./TableBody";

import styles from "./styles.module.css";
import { SortState, getColumnSortType, getNextSortState } from "./tableSort.utils";

interface PatientProps {
  Id: number;
  SeqAtend: number;
  Paciente: string;
  Clinica?: string;
  Status: string;
  DataAtend: string;
  DataNasc: string;
  Idade: string;
  Indicacao: string;
  IdPaciente: number;
  Sexo: string;
  Telefone: string | null;
  Imagem: string;
  TodosExames: any[] | null;
  ImagensPaciente: any[] | null;
  Exames: any[] | null;
  Cefalometrias: any[] | null;
  ControleProcessos: any[] | null;
  VideosPaciente: any[] | null;
  TipoUsuario: string | null;
  SS: string;
}

interface TableProps {
  list: any;
  amount?: number;
  data: any;
  getScrollTo?: any;
  sortState: SortState;
  onSortChange: (sortState: SortState) => void;
  noPatientsCefx?: boolean;
  loadingButtonChecklist?: boolean;
  noResultSearch?: boolean;
}

export function Table({
  getScrollTo,
  sortState,
  onSortChange,
  list,
  amount,
  noPatientsCefx,
  loadingButtonChecklist,
  noResultSearch,
  data: { patientList },
}: TableProps) {
  const arrowSize = 12;

  const handleReorder = (prop: string) => {
    onSortChange(getNextSortState(prop, sortState));
  };
  const OpenWhatsapp = () => {
    // var numeros = infoPacient.telefone.replace(/\D/g, "");
    // var numeroDesejado = numeros.substring(0, 10);
    // window.location.href = "https://wa.me/55" + numeroDesejado;
  };

  return (
    <section className={styles.container}>
      <div className={styles.container_table}>
        <table>
          <thead>
            <tr>
              <th>
                <div>
                  Paciente
                  <span className={styles.upDownIconsContainer}>
                    {getColumnSortType("paciente", sortState) === "up" ? (
                      <ChevronUpIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("paciente")}
                      />
                    ) : (
                      <ChevronDownIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("paciente")}
                      />
                    )}
                  </span>
                </div>
              </th>
              <th>
                <div>
                  Data
                  <span className={styles.upDownIconsContainer}>
                    {getColumnSortType("dataAtend", sortState) === "up" ? (
                      <ChevronUpIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("dataAtend")}
                      />
                    ) : (
                      <ChevronDownIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("dataAtend")}
                      />
                    )}
                  </span>
                </div>
              </th>
              <th>
                <div>
                  Idade
                  <span className={styles.upDownIconsContainer}>
                    {getColumnSortType("dataNasc", sortState) === "up" ? (
                      <ChevronUpIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("dataNasc")}
                      />
                    ) : (
                      <ChevronDownIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("dataNasc")}
                      />
                    )}
                  </span>
                </div>
              </th>
              <th>
                <div>
                  Indicação
                  <span className={styles.upDownIconsContainer}>
                    {getColumnSortType("indicacao", sortState) === "up" ? (
                      <ChevronUpIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("indicacao")}
                      />
                    ) : (
                      <ChevronDownIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("indicacao")}
                      />
                    )}
                  </span>
                </div>
              </th>
              <th>
                <div>
                  Clínica
                  <span className={styles.upDownIconsContainer}>
                    {getColumnSortType("clinic", sortState) === "up" ? (
                      <ChevronUpIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("clinic")}
                      />
                    ) : (
                      <ChevronDownIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("clinic")}
                      />
                    )}
                  </span>
                </div>
              </th>
              <th>
                <div>
                  Previsão
                  <span className={styles.upDownIconsContainer}>
                    {getColumnSortType("dataAtend", sortState) === "up" ? (
                      <ChevronUpIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("dataAtend")}
                      />
                    ) : (
                      <ChevronDownIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("dataAtend")}
                      />
                    )}
                  </span>
                </div>
              </th>
              <th>
                <div>
                  Situação
                  <span className={styles.upDownIconsContainer}>
                    {getColumnSortType("status", sortState) === "up" ? (
                      <ChevronUpIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("status")}
                      />
                    ) : (
                      <ChevronDownIcon
                        width={arrowSize}
                        className={styles.upDownIcons}
                        onClick={() => handleReorder("status")}
                      />
                    )}
                  </span>
                </div>
              </th>
              <th>Compartilhar</th>
            </tr>
          </thead>
          {noResultSearch ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "2rem",
                opacity: ".9",
                color: "#c80000",
              }}
            >
              Paciente não foi encontrado.
            </p>
          ) : (
            list?.data.map((patient: PatientProps, index: number) => {
              return (
                <TableBody
                  key={index}
                  bodyContents={!patient ? [] : patient}
                  getScrollTo={getScrollTo}
                />
              );
            })
          )}
        </table>
      </div>
    </section>
  );
}
